import { Link } from "@tanstack/react-router";

import footerWordmark from "@/assets/adapted-wordmark-light.webp.asset.json";
import { navLinks } from "./SiteHeader";
import { SocialLinksBar } from "./SocialLinksBar";

export function SiteFooter() {
  return (
    <footer className="surface-ink relative py-16">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1.2fr)_repeat(2,minmax(0,1fr))]">
          <div>
            <img
              src={footerWordmark.url}
              alt="adaptED"
              width={600}
              height={147}
              loading="lazy"
              decoding="async"
              className="h-9 w-auto"
            />
            <p className="mt-4 max-w-xs text-sm text-ink-foreground/75">
              We are building safe, learning-first AI technology for South African learners, designed for better results today and greater possibilities tomorrow.
            </p>
          </div>

          <div>
            <h3 className="font-display text-sm font-bold text-ink-foreground">Pages</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-ink-foreground/75 transition-colors hover:text-primary-on-ink"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/join-the-pilot"
                  className="text-sm text-ink-foreground/75 transition-colors hover:text-primary-on-ink"
                >
                  Join the Pilot
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-sm font-bold text-ink-foreground">Get in touch</h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-ink-foreground/75 transition-colors hover:text-primary-on-ink"
                >
                  Contact us
                </Link>
              </li>
              <li>
                <Link
                  to="/join-the-pilot"
                  search={{ type: "school" }}
                  className="text-sm text-ink-foreground/75 transition-colors hover:text-primary-on-ink"
                >
                  Register your school
                </Link>
              </li>
              <li>
                <Link
                  to="/past-papers"
                  className="text-sm text-ink-foreground/75 transition-colors hover:text-primary-on-ink"
                >
                  Past Papers
                </Link>
              </li>
              <li>
                <Link
                  to="/grade-11-past-papers"
                  className="text-sm text-ink-foreground/75 transition-colors hover:text-primary-on-ink"
                >
                  Grade 11 Past Papers
                </Link>
              </li>
              <li>
                <Link
                  to="/grade-12-past-papers"
                  className="text-sm text-ink-foreground/75 transition-colors hover:text-primary-on-ink"
                >
                  Grade 12 Past Papers
                </Link>
              </li>
              <li>
                <a
                  href="https://www.quizzyonline.co.za"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm text-ink-foreground/75 transition-colors hover:text-primary-on-ink"
                >
                  Quizzy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-6 border-t border-ink-foreground/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <SocialLinksBar />
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-ink-foreground/75">
            <Link to="/terms" className="transition-colors hover:text-primary-on-ink">
              Terms of Service
            </Link>
            <span aria-hidden="true">·</span>
            <Link to="/privacy" className="transition-colors hover:text-primary-on-ink">
              Privacy Policy
            </Link>
            <span aria-hidden="true">·</span>
            <Link to="/auth" className="transition-colors hover:text-primary-on-ink">
              Staff
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
